export default __webpack_public_path__ + "static/media/02.d6e2968e.svg";